function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgMedicalSecondOpinion = function SvgMedicalSecondOpinion(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 57 56"
  }, props), /*#__PURE__*/React.createElement(Path, {
    stroke: props.accentFillLine,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M14.623 29.027c0 1.004 1.12 1.917 1.724 2.13.603-.213 1.723-1.126 1.723-2.13 0-.555-.424-1.004-.948-1.004a.93.93 0 0 0-.775.427.93.93 0 0 0-.776-.427c-.524 0-.948.45-.948 1.004"
  }), /*#__PURE__*/React.createElement(Path, {
    stroke: props.fillLine,
    strokeMiterlimit: 10,
    d: "M40.036 37.848v9.053c0 1.16-.67 2.1-1.498 2.1h-20.45c-.826 0-1.498-.94-1.498-2.1v-9.053M16.592 15.09V6.767c0-1.16.67-2.1 1.498-2.1h20.45c.826 0 1.498.94 1.498 2.1v8.323"
  }), /*#__PURE__*/React.createElement(Path, {
    stroke: props.fillLine,
    strokeMiterlimit: 10,
    d: "M38.05 40.797v2.254c0 .283-.34.514-.756.514H19.276c-.417 0-.756-.231-.756-.514v-2.254"
  }), /*#__PURE__*/React.createElement(Path, {
    stroke: props.accentFillLine,
    strokeMiterlimit: 10,
    d: "M18.52 13.473v-5.35c0-.463.34-.84.756-.84h18.02c.417 0 .756.377.756.84v5.35"
  }), /*#__PURE__*/React.createElement(Path, {
    stroke: props.fillLine,
    strokeMiterlimit: 10,
    d: "m23.834 37.846.41 3.286a.189.189 0 0 1-.279.189l-6.309-3.475H7.267a2.1 2.1 0 0 1-2.1-2.1V17.19c0-1.16.94-2.1 2.1-2.1h16.961c1.161 0 2.1.94 2.1 2.1v18.553a2.1 2.1 0 0 1-2.1 2.1h-.394z"
  }), /*#__PURE__*/React.createElement(Path, {
    stroke: props.accentFillLine,
    strokeMiterlimit: 10,
    d: "m32.25 37.846-.409 3.286a.189.189 0 0 0 .278.189l6.31-3.475h10.388a2.1 2.1 0 0 0 2.1-2.1V17.19a2.1 2.1 0 0 0-2.1-2.1h-16.96a2.1 2.1 0 0 0-2.101 2.1v18.553c0 1.16.94 2.1 2.1 2.1h.395z"
  }), /*#__PURE__*/React.createElement(Path, {
    stroke: props.accentFillLine,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M38.83 22.045h4.94m-.353 3.65a4.94 4.94 0 0 1 2.823 4.464v1.412c0 .779-.632 1.41-1.412 1.41h-7.056c-.779 0-1.41-.631-1.41-1.41v-1.412a4.94 4.94 0 0 1 2.822-4.463m2.117.582a2.47 2.47 0 0 1-2.47-2.469v-3.175c0-.78.632-1.411 1.411-1.411h2.117c.78 0 1.411.632 1.411 1.41v3.176a2.47 2.47 0 0 1-2.47 2.47"
  }), /*#__PURE__*/React.createElement(Path, {
    stroke: props.fillLine,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.942,
    d: "M39.889 29.808h2.822m-1.411 1.41v-2.822"
  }), /*#__PURE__*/React.createElement(Path, {
    stroke: props.fillLine,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M13.831 21.995h4.851m-.346 3.585a4.85 4.85 0 0 1 2.772 4.384v1.386c0 .766-.62 1.386-1.386 1.386h-6.93c-.766 0-1.386-.62-1.386-1.386v-1.386a4.85 4.85 0 0 1 2.772-4.384m2.079.573a2.425 2.425 0 0 1-2.426-2.426V20.61c0-.766.62-1.386 1.386-1.386h2.08c.765 0 1.385.62 1.385 1.386v3.118a2.425 2.425 0 0 1-2.425 2.426"
  }));
};
export default SvgMedicalSecondOpinion;